import { GiPlatform } from "react-icons/gi";
import { AiOutlineSolution } from "react-icons/ai";
import { SiCountingworkspro } from "react-icons/si";
import { BsBoundingBox } from "react-icons/bs";
import { MdOutlineReviews } from "react-icons/md";
import { RxSection } from "react-icons/rx";
import { IoPeopleOutline } from "react-icons/io5";

export const RoutePath = {
  platform: "platform",
  solutions: "solutions",
  productDetails: "products/details",
  productList: "products/list",
  productAdd: "products/add",
  productUnique: "products/:id",
  whyUs: "why-us",
  clientList: "clients",
  clientAdd: "client/add",
  clientUnique: "client/:id",
  reviewList: "reviews",
  reviewAdd: "review/add",
  reviewUnique: "review/:id",
  footer: "footer",
  login: "login",
};

export const sideBarNavigation = [
  {
    title: "Platform",
    url: RoutePath.platform,
    icon: <GiPlatform />,
  },
  {
    title: "solutions",
    url: RoutePath.solutions,
    icon: <AiOutlineSolution />,
  },
  {
    title: "Our Clients",
    url: RoutePath.clientList,
    icon: <IoPeopleOutline />,
  },
  {
    title: "products",
    url: "#",
    icon: <BsBoundingBox />,
    subUrl: [
      {
        title: "Products details",
        url: `${RoutePath.productDetails}`,
      },
      {
        title: "Products list",
        url: `${RoutePath.productList}`,
      },
    ],
  },
  {
    title: "why bangla haat",
    url: RoutePath.whyUs,
    icon: <SiCountingworkspro />,
  },
  {
    title: "Client Reviews",
    url: RoutePath.reviewList,
    icon: <MdOutlineReviews />,
  },
  {
    title: "Footer",
    url: RoutePath.footer,
    icon: <RxSection />,
  },
];

export const apiPath = {
  homeApi: "home",
  clientsApi: "clients",
  productApi: "product",
  productsApi: "products",
  footerApi: "footer",
};

export const getToken = () => {
  const tempToken = sessionStorage.getItem("ebc202c5c66c906f41dfee622fb64242")
    ? sessionStorage.getItem("ebc202c5c66c906f41dfee622fb64242")
    : "69420";

  return decryptToken(tempToken);
};

export const decryptToken = (tempToken) => {
  let charPlace = tempToken.indexOf(".");
  let payLoad = tempToken.slice(0, charPlace + 1);
  let legitToken = tempToken.slice(charPlace + 11);
  return payLoad + legitToken;
};
